import { useMemo } from "react";

import { useEmailTemplatesContext } from "@/components/modules/email-templates-sidebar/context";
import { useHandlerRemoveEmailFromSequence } from "@/components/modules/email-templates-sidebar/hooks";

import { Button } from "shared/ui/shadcn/button";

export const DeleteFollowupEmailButton = () => {
  const {
    drafts,
    activeTemplateId,
    activeEmailSequenceItemId,
    isAIGenerationStarted,
    isAIGenerationComplete,

    getDraft,
  } = useEmailTemplatesContext();

  const {
    handler: handlerRemoveEmailFromSequence,
    isPending: isRemovingEmailFromSequence,
  } = useHandlerRemoveEmailFromSequence();

  const draft = useMemo(() => {
    return getDraft(activeTemplateId as string);
  }, [drafts, activeTemplateId]);

  const followUpEmail = useMemo(() => {
    return draft?.emails?.find(
      (email) => email.email_id === activeEmailSequenceItemId
    );
  }, [draft, activeEmailSequenceItemId]);

  const isAIGenerationInProgress = useMemo(() => {
    return isAIGenerationStarted && !isAIGenerationComplete;
  }, [isAIGenerationStarted, isAIGenerationComplete]);

  /**
   * Remove the followup email from the sequence
   * and set the first email as active
   * and recalculate days for each email in the sequence
   */
  const handleRemoveEmailFromSequence = (emailId: string) => async () => {
    handlerRemoveEmailFromSequence(emailId);
  };

  return (
    <Button
      variant="destructive"
      className="border border-[#B80707] bg-transparent text-[#B80707] hover:text-white"
      disabled={isRemovingEmailFromSequence || isAIGenerationInProgress}
      onClick={handleRemoveEmailFromSequence(followUpEmail?.email_id as string)}
    >
      Delete follow-up
    </Button>
  );
};
